import { useQuery } from 'react-query'

import axiosInstance from 'api/axiosInstance'
import { type Response } from 'api/types/Response'

export type StreamLiveDataResponse = {
  channel: {
    arn: string
    ingestEndpoint: string
  }
  streamKey: {
    arn: string
    value: string
  }
}

const getStreamingData = async () => {
  const { data: res } =
    await axiosInstance.get<Response<StreamLiveDataResponse>>(
      '/api/user/live'
    )

  return res.data
}

interface UseStreamingDataOptions {
  enabled?: boolean
}

export const useStreamingData = (options?: UseStreamingDataOptions) => {
  return useQuery(['streaming-data'], getStreamingData, {
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: false
  })
}